import { type Interceptor } from '@connectrpc/connect';
import { authQueryKey } from '@/api/query-keys';
import { type AuthDto } from '@/api/services/auth';
import { ctxKeyAuthorized, ctxKeyQueryClient } from '@/connect-query/context-keys';
import { missingQueryFnHandler } from '../missing-query-fn';

/**
 * Authorization interceptor to add `Authorization` header to all requests.
 * This is conditional depending on the context value `ctxKeyAuthorized`.
 */
export const authorizationInterceptor: Interceptor = (next) => async (req) => {
  const isAuthorizedRequest = req.contextValues.get(ctxKeyAuthorized);
  if (isAuthorizedRequest) {
    const queryClient = req.contextValues.get(ctxKeyQueryClient);
    const { sessionToken } = await missingQueryFnHandler(queryClient.fetchQuery<AuthDto>({ queryKey: authQueryKey }));
    req.header.append('Authorization', `Bearer ${sessionToken}`);
  }
  return next(req);
};
